import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import Weather from './Weather'; 

function App() {
  return (
    <div className="App">
      <div className="container">
      <Weather defaultCity="Lisbon" />
      <footer>      
 <a href="https://github.com/rcgatt/shecodes-reactproject"> Open-sourced project coded by C.Gatete
 </a>
      </footer>
      </div> 
    </div>
  );
}

export default App;
